module.exports = "delete-trashcan"